import { primitiveTokens, semanticThemeTokens } from "@appretio/ui-kit";
import { style } from "@vanilla-extract/css";

export const formContainer = style({
  display: "flex",
  flexDirection: "column",
  gap: primitiveTokens.sizing["2x"],
  paddingTop: primitiveTokens.sizing["2x"],
  paddingBottom: primitiveTokens.sizing["2x"]
});

export const advancedOptions = style({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start"
});

export const advancedOptionsFields = style({
  // The parent aligns flex-start so the disclosure button doesn't stretch;
  // the panel must, or its selects shrink to their intrinsic width.
  alignSelf: "stretch",
  display: "flex",
  flexDirection: "column",
  gap: primitiveTokens.sizing["2x"],
  marginTop: primitiveTokens.sizing["2x"],
  paddingTop: primitiveTokens.sizing["2x"],
  borderTop: `1px solid ${semanticThemeTokens.divider.backgroundColor}`
});

export const weekRangeRow = style({
  display: "flex",
  gap: primitiveTokens.sizing["2x"]
});

export const weekRangeItem = style({
  flex: 1
});

// Mirrors the ui-kit Label's text; Label itself forces its own row.
export const groundTruth = style({
  fontSize: primitiveTokens.type.xs,
  color: semanticThemeTokens.label.color.regular
});
